import { nextTick, ref, watch } from 'vue';

/**
 * Remembers where a table was scrolled to while the conversation opened from it
 * is on screen, so the back arrow lands on the row the agent left from.
 *
 * The offset is read before the table is hidden, because hiding a scroll
 * container drops its scroll position.
 *
 * @param {import('vue').Ref<boolean>} isVisible Whether the table is on screen.
 * @returns {import('vue').Ref<HTMLElement>} The scroll container ref.
 */
export function useTableScrollMemory(isVisible) {
  const scrollRef = ref(null);
  let offset = 0;

  watch(isVisible, visible => {
    if (!visible) {
      offset = scrollRef.value?.scrollTop ?? 0;
      return;
    }
    nextTick(() => {
      if (scrollRef.value) scrollRef.value.scrollTop = offset;
    });
  });

  return scrollRef;
}
